import { Component, Inject, Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};
@Injectable({ providedIn: 'root' })

export class ChangePasswordService {

  baseUrl: string
  constructor(private http: HttpClient) { }
  checkoldpassword(password: string, username: string) {
    this.baseUrl = environment.serviceUrl;
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post(this.baseUrl + 'api/UserApi/checkoldpassword', { password, username }, { headers: header, observe: 'response' });
  }
 changepassword(password: string,  useridstr: string) {
   
   this.baseUrl = environment.serviceUrl;
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
   return this.http.post(this.baseUrl + 'api/UserApi/changepassword', { password,  useridstr }, { headers: header, observe: 'response' });
  }

}
